var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = new Map();
    }
    EventEmitter.prototype.addListener = function (label, callback) {
        this.listeners.has(label) || this.listeners.set(label, []);
        this.listeners.get(label).push(callback);
    };
    EventEmitter.prototype.removeListener = function (label, callback) {
        var listeners = this.listeners.get(label), index;
        if (listeners && listeners.length) {
            index = listeners.reduce(function (i, listener, index) {
                return (EventEmitter.isFunction(listener) && listener === callback) ?
                    i = index : i;
            }, -1);
            if (index > -1) {
                listeners.splice(index, 1);
                this.listeners.set(label, listeners);
                return true;
            }
        }
        return false;
    };
    EventEmitter.prototype.emit = function (label) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this.listeners.get(label);
        if (listeners && listeners.length) {
            listeners.forEach(function (listener) {
                listener.apply(void 0, args);
            });
            return true;
        }
        return false;
    };
    EventEmitter.isFunction = function (obj) {
        return typeof obj === 'function' || false;
    };
    ;
    return EventEmitter;
}());
export default EventEmitter;
